interface Incident {
  pagerDutyIncident?: { title?: string };
  incidentIoIncident?: { title?: string };
  slackIncident?: { title?: string };
}

interface ChatMessage {
  id: string;
  content: string;
  sender: 'user' | 'annie';
  timestamp: string;
}

export const getIncidentTitle = (
  incident: Incident | undefined,
  incidentId: string,
): string => {
  if (!incident) {
    return `Incident ${incidentId}`;
  }

  const pagerDutyTitle = incident.pagerDutyIncident?.title;
  const incidentIoTitle = incident.incidentIoIncident?.title;
  const slackTitle = incident.slackIncident?.title;

  return (
    pagerDutyTitle ?? incidentIoTitle ?? slackTitle ?? `Incident ${incidentId}`
  );
};

export const createMockMessage = (
  content: string,
  sender: 'user' | 'annie',
): ChatMessage => ({
  id: `chat-${sender === 'user' ? '' : 'annie-'}${Date.now()}`,
  content,
  sender,
  timestamp: new Date().toISOString(),
});

export const getMockAnnieResponse = (): string =>
  "I'm analyzing your question and will provide more details based on the investigation data available.";
